/*
  File name: default.js
    Program Description:
    - This file sets the default state values that can be accessed by the
    system.
*/

const state = {
  sex: ['Male', 'Female'],
  month: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],
  userRole: [
    { name: 'Administrator', value: 'admin' },
    { name: 'Assignor', value: 'assignor' },
    { name: 'Evaluator', value: 'evaluator' },
    { name: 'Reviewer', value: 'reviewer' },
    { name: 'Dasco User', value: 'dascoUser' },
    { name: 'Division Chief', value: 'divisionChief' },
    { name: 'Recipient (Adjudication)', value: 'adjudicationRecipient' },
    { name: 'Recipient (Investigation)', value: 'investigationRecipient' },
    { name: 'Recipient (Enforcement)', value: 'enforcementRecipient' }
  ]
}

export default {
  state,
  namespaced: true
}
